/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useCallback } from "react";

import CardAtendimentoPrateleiraInfinita from "components/Cards/Cards/CardAtendimentoPrateleiraInfinita";

import { IconButton } from "@material-ui/core";

import { Add as AddIcon } from "@material-ui/icons";

import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import {
  columnTextField,
  columnDateField,
  columnPriceField,
} from "utils/tables-utils";

export default function TablePedidosPrateleiraInfinita({
  dataTable,
  search,
  currentSizePerPage,
  currentPage,
  totalRegistros,
  hideFilters,
  statusConsulta,
}) {
  const [loading, setLoading] = useState(false);
  const [pedidoSelecionado, setPedidoSelecionado] = useState(null);

  const handleSelectOrder = (data) => {
    setPedidoSelecionado({
      ...data,
      ...data.Itens.find(
        (pedido) => pedido.IdAtendimentoApp === data.IdAtendimentoApp
      ),
    });
    hideFilters(true);
  };

  const showMenu = (cell, row) => {
    return (
      <div>
        <IconButton
          variant="contained"
          size="small"
          style={{ padding: "0px" }}
          title={"Mais detalhes do atendimento " + row.IdAtendimentoApp}
          onClick={() => handleSelectOrder(row)}
        >
          <AddIcon />
        </IconButton>
      </div>
    );
  };

  const columnModel = [
    {
      dataField: "menu",
      text: "",
      isDummyField: true,
      formatter: showMenu,
      csvExport: false,
    },
    columnTextField({
      dataField: "Apelido",
      text: "Loja",
      align: "left",
    }),
    columnTextField({
      dataField: "IdPedidoEcommerce",
      text: "Pedido",
      align: "center",
    }),
    columnTextField({
      dataField: "StatusDescricaoPedEcomm",
      text: "Status do Pedido",
      align: "center",
      formatter: (value) => {
        const status = value?.toLowerCase();
        return status[0].toUpperCase() + status?.substring(1);
      },
    }),
    columnTextField({
      dataField: "Status",
      text: "Situação do XML",
      align: "center",
    }),
    columnDateField(
      {
        dataField: "DataEmissaoPedido",
        text: "Data do Pedido",
      },
      true
    ),
    columnPriceField(
      {
        dataField: "ValorTotalPedido",
        text: "Valor Total",
      },
      false
    ),
    columnTextField({
      dataField: "Descricao",
      text: "Cliente",
      align: "center",
    }),
  ];

  const doSearch = useCallback(async (page, sizePerPage) => {
    setLoading(true);

    await search({ page, sizePerPage });

    setLoading(false);
  }, []);

  const handlePageChange = useCallback(
    (page, sizePerPage) => {
      doSearch(page, sizePerPage);
    },
    [doSearch]
  );

  const handleSizePerPageChange = useCallback(
    (sizePerPage, page) => {
      doSearch(page, sizePerPage);
    },
    [doSearch]
  );

  return (
    <>
      {pedidoSelecionado !== null ? (
        <CardAtendimentoPrateleiraInfinita
          dataOrder={pedidoSelecionado}
          dataTable={pedidoSelecionado?.Itens}
          statusConsulta={statusConsulta}
          setPedidoSelecionado={setPedidoSelecionado}
          hideFilters={hideFilters}
        />
      ) : (
        <ToolkitTable
          searched={Boolean(dataTable)}
          keyField="IdAtendimentoApp"
          dataTable={dataTable}
          columnModel={columnModel}
          headerTitle="Pedidos Prateleira Infinita"
          styledRow={{
            cursor: "pointer",
          }}
          onRowClick={(_, row) => handleSelectOrder(row)}
          pagination={{
            options: [25, 50, 100],
            defaultOption: currentSizePerPage,
            totalSize: totalRegistros,
            showTotal: true,
            page: currentPage,
            onPageChange: handlePageChange,
            sizePerPage: currentSizePerPage,
            onSizePerPageChange: handleSizePerPageChange,
          }}
          loading={loading}
          notFoundTitle="Sua pesquisa não encontrou nenhum resultado correspondente."
          bootstrapTableProps={{
            remote: true,
            onTableChange: () => {},
          }}
        />
      )}
    </>
  );
}
